import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";
import "./index.css";
import "react-tooltip/dist/react-tooltip.css";
import { baseURL } from "./utils";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENTID}
    authorizationParams={{
      redirect_uri: `${baseURL()}/account`,
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    }}
  >
    <App />
  </Auth0Provider>

  // </React.StrictMode>
);
